const templates =  {
    "shop.okraina.ru": {
        title: "Итоги года",
        tags: [

        ]
    },
    "dostavka.okraina.ru": {
        title: "Итоги года",
        tags: [

        ]
    },
}

export default templates;